import { colors, typography } from '@insurancemenu/imenu-components-lib';
import styled, { CSSProp } from 'styled-components';

export const SectionTitleStyled = styled.div<{ $withSubtitle: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border-bottom: 0.1rem solid ${colors.neutral[300]};
  padding-bottom: ${({ $withSubtitle }): CSSProp => ($withSubtitle ? '2rem' : '1.5rem')};

  /* Useful when the title is inside an flex container */
  width: 100%;
`;

export const TitleStyled = styled.h3`
  ${typography.bold[24]};
  color: ${colors.neutral[900]};
  margin: 0;
`;

export const SubtitleStyled = styled.p`
  ${typography.regular[16]};
  color: ${colors.neutral[700]};
  margin: 0;
`;
